import React, { useState, useEffect, useRef } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import { DataProvider } from '../Components/DataContext';
import storage from '../Components/storage';
import { CajaProvider, useCaja } from '../Components/Worker/CajaContext';
import AbrirCajaModal from '../Components/Worker/AbrirCajaModal';
import ElegirCajaModal from '../Components/Worker/ElegirCajaModal';
import CajaBar from '../Components/Worker/CajaBar';
import { usePlan } from '../Components/PlanContext';
import { ruta } from '../Components/paths';
import baseURL from '../Components/url';

function WorkerContenido() {
    const { caja, cajasAbiertas, loading: cajaLoading } = useCaja();
    const { features } = usePlan();
    const cajaHabilitada = features?.cajaDiaria;
    const [mostrarAbrir, setMostrarAbrir] = useState(false);

    if (cajaLoading) return <Spiner />;

    return (
        <>
            {cajaHabilitada && <CajaBar />}
            <Outlet />
            {cajaHabilitada && !caja && (mostrarAbrir || cajasAbiertas.length === 0) && <AbrirCajaModal />}
            {cajaHabilitada && !caja && !mostrarAbrir && cajasAbiertas.length > 0 && (
                <ElegirCajaModal onAbrirNueva={() => setMostrarAbrir(true)} />
            )}
        </>
    );
}

export default function WorkerLayout() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const expulsadoRef = useRef(false);

    useEffect(() => {
        let interval = null;
        let cancelado = false;
        expulsadoRef.current = false;

        const expulsar = () => {
            if (expulsadoRef.current) return;
            expulsadoRef.current = true;
            storage.removeItem('adminUser');
            setUsuario({});
            navigate(ruta('/trabajador'), { replace: true });
        };

        const validarSesion = async () => {
            try {
                const r = await fetch(`${baseURL}/userLogued.php`, { credentials: 'include' });
                const data = await r.json();
                if (cancelado) return;
                if (data && data.idUsuario) {
                    // La sesión PHP es válida en ESTE tenant.
                    setUsuario(data);
                    if (data.rol === 'admin') {
                        navigate(ruta('/dashboard'), { replace: true });
                        return;
                    }
                    // Heartbeat: si la sesión expira a mitad de uso, expulsa.
                    interval = setInterval(async () => {
                        try {
                            const hr = await fetch(`${baseURL}/userLogued.php`, { credentials: 'include' });
                            const hd = await hr.json();
                            if (!hd || !hd.idUsuario) {
                                expulsar();
                            }
                        } catch (e) {
                            // Sin conexión momentánea: no expulsar.
                        }
                    }, 60000);
                } else {
                    // Sin sesión válida en este tenant: limpiar y pedir login.
                    expulsar();
                }
            } catch (err) {
                if (cancelado) return;
                // Error de red momentáneo: no expulsar. Sin sesión confirmada se muestra login.
            } finally {
                if (!cancelado) setLoading(false);
            }
        };

        validarSesion();

        return () => {
            cancelado = true;
            if (interval) clearInterval(interval);
        };
    }, [navigate, location.pathname]);

    return (
        <div>
            {loading ? (
                <Spiner />
            ) : usuario?.idUsuario && usuario?.rol === 'trabajador' ? (
                <DataProvider autoLoad={['bootstrap']}>
                    <CajaProvider>
                        <WorkerContenido />
                    </CajaProvider>
                </DataProvider>
            ) : (
                <Auth />
            )}
        </div>
    );
}